<template>
    <div class="Visdoctor">
        <template>
            <el-table :data="tableData" border style="width: 100%;" :header-cell-style="tableHeaderColor">
                <el-table-column label="时间" width="auto">
                    <template scope="scope">
                        <el-icon name="warning"
                                 :class="{backgroundColor:scope.row.emergency==true ? active : !active}"></el-icon>
                        <span style="margin-left: 10px">{{ scope.row.periodOfTime }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="预约人" width="auto">
                    <template scope="scope">
                        <div slot="reference" class="name-wrapper">
                            <div>{{ scope.row.patient.name }},{{ scope.row.patient.age }},{{
                                scope.row.patient.gender }}
                            </div>
                            <div>{{ scope.row.patient.mobileNumber }}</div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="patient.level" label="会员等级" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.patient.level==='1' ? 'normal' : (scope.row.patient.level==='2' ? 'warning'
                            : (scope.row.patient.level==='3'?'danger':'success'))">
                            {{scope.row.patient.level === '1' ? '普通会员' : (scope.row.patient.level === '2' ? '银卡会员'
                            : (scope.row.patient.level === '3' ? '金卡会员' : '铂金会员'))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="看诊医生" width="100">
                    <template scope="scope">
                        <div slot="reference" class="name-wrapper">
                            <p class="phone-s">{{ scope.row.doctorName }}</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="状态" width="auto" style="text-aligin:left;" prop="reservationStatus"
                                 :filters="[{ text:'候诊' , value: 1 }, { text: '看诊', value: 2 }, { text: '结束看诊', value:  3}]"
                                 :filter-method="filterTag"
                                 filter-placement="bottom-end">
                    <template scope="scope">
                        <el-tag :type="scope.row.reservationStatus==1?'success':'info'">候诊</el-tag>
                        <el-tag :type="scope.row.reservationStatus==2?'success':'info'">看诊</el-tag>
                        <el-tag :type="scope.row.reservationStatus==3?'success':'info'">结束看诊</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="checkInDateTime" label="签到时间" width="160"></el-table-column>
                <el-table-column label="操作" width="auto" style="text-aligin:left;">
                    <template scope="scope">
                        <el-button
                                v-if="scope.row.reservationStatus!=0"
                                disabled
                                type="primary"
                                icon="el-icon-edit-outline"
                        >已签到
                        </el-button>
                        <el-button
                                v-else
                                type="primary"
                                icon="el-icon-edit-outline"
                                v-on:click.stop="signIn(scope.$index,tableData)"
                        >签到
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>
<script>
    import "../../assets/css/style1.css"

    export default {
        name: 'home',
        data: function () {
            return {
                active: true,
                tableData: [],
                doctorName: '',
                // timeOut: null					// 周期性定时器
            }
        },
        props: ['dId'],
        methods: {
            filterTag(value, row) {
                return row.reservationStatus === value;
            },
            signIn(index, rows) {						// 点击签到
                console.log(rows[index].reservationId);
                this.$axios({
                    url: "/api/reservation/signup/" + rows[index].reservationId,
                    method: "PUT"
                }).then(res => {
                    this.refreshData();
                    this.$message({
                        type: 'success',
                        message: '签到成功'
                    });
                }).catch(err => {
                    // console.log(err);
                });
            },
            refreshData() {
                this.doctorName = this.dId.name;
                this.$axios({
                    url: "/api/reservation/" + this.dId.id,
                    method: "GET"
                }).then(res => {
                    let resData = res.data.data;
                    this.tableData = resData;
                    //this.timeOut = setTimeout(() => {
                    //    this.refreshData();
                    //}, 6000);
                }).catch(err => {
                    console.log(err);
                    clearTimeout(this.timeOut);
                });
            },
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return "background-color:#f2f2f2;color: #a4a7af;";
                }
            },
        },
        watch: {
            dId() {
                // console.log(this.dId);
                this.refreshData();
            }
        },
        created() {
            // console.log(this.dId);
            this.refreshData();
        },
        destroyed() {
            clearTimeout(this.timeOut);
            console.log('关闭计时器');
        }
    }
</script>
<style type="text/css" scoped>
    body {
        background-color: #F6F6F6;
    }

    .backgroundColor {
        color: red;
        font-size: 20px;
        font-weight: bold;
    }

    .Visdoctor .name-span span {
        margin-left: 25px;
    }

    .Visdoctor .name-wrapper {
        text-align: left;
    }

    .Visdoctor .phone-s {
        width: 175px;
    }

    .el-button--primary {
        color: #fff;
        background-color: rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }

    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }

    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// Visdoctor.vue?52077dae